module.exports = __webpack_public_path__ + "static/main-background-bfe5f8c25017f98e0b0aa76b90c54fd8.jpg";